
(function ($, d, ns) {
    ns.initBrokerTable = function () {
        $('.js-broker-control').on('click', function (e) {
            e.preventDefault();
            var associatedControl = $(this).attr('data-expanded-element');
            var linktext = 'Hide wines sold by clients';

            if ($(this).hasClass('active')) {
                linktext = 'View wines sold by clients';
            }

            $(this).html(linktext);
            $(this).toggleClass('active');
            $('.' + associatedControl).toggleClass('active');
        });
    };

    $(d).ready(function () {
        ns.initBrokerTable();
    });


})(jQuery, document, Crafted.Utilities);